import { IClaim } from 'features/claims/types'
import { CardTabs } from '@outbound-ai/ursa'

import { ClaimDetailsComments } from './ClaimDetailsComments'
import { ClaimDetailsHistoryList } from './ClaimDetailsHistory'

// eslint-disable-next-line import/named
interface IClaimDetailsHistoryProps {
  claim?: IClaim
}

export const ClaimDetailsHistoryAndComments = ({ claim }: IClaimDetailsHistoryProps): JSX.Element => {
  if (!claim) {
    return <div>Claim ID not is missing</div>
  }
  return (
    <CardTabs
      tabs={[
        {
          tabs: 'History',
          tabContent: <ClaimDetailsHistoryList claim={claim} />,
        },
        {
          tabs: 'Comments',
          tabContent: <ClaimDetailsComments claimId={claim?.oaiClaimId} archived={claim.archived} />,
        },
      ]}
    />
  )
}
